import makeStyles from "@material-ui/core/styles/makeStyles";
import colors from "Styles/colors";

const useStyles = makeStyles({
  border: {
    width: "100%",
    padding: 66,
    border: `4px solid ${colors.whiteBlue}`,
  },
  image: {
    maxWidth: 150,
    float: "right",
  },
  textContainer: {
    alignSelf: "center",
    paddingLeft: 11,
  },
  sorry: {
    fontWeight: "normal",
  },
  searchInput: {
    marginBottom: 20,
  },
});

export default useStyles;
